<template>
  <div>
    <!-- 날짜 -->
    <div class="absolute top-0 flex items-center gap-4" :class="[!isPrint && 'py-6']" style="left: calc(180px + 1.5rem)">
      <div class="flex items-center justify-center gap-3">
        <p v-if="isPrint" class="print-input">{{ form.headerYear | moment("YYYY") }}</p>
        <input v-else type="number" :readonly="board.readonly || isPostId" min="1800" max="9999" v-model="form.headerYear" style="width: 100px" />
        년
      </div>
    </div>

    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="fieldTypes"
      :typeslabel="{
        date: '최초 작성일',
        updated_at: '최종 수정일',
      }"
    />

    <!-- List -->
    <div>
      <table-stock v-for="(stock, stock_i) in stockTitles" :key="`table_${stock}`" :isPrint="isPrint" :readonly="board.readonly || readonlyYear" :title="stock" v-model="form[`stockList${stock_i + 1}`]" class="mt-5" />
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-5" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableStock from "@/components/TableStock.vue";
import moment from "moment";

export default {
  components: {
    TableStock,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      readonlyYear: false,
      stockTitles: ["소화기계약", "호흡기계약", "근육이완제(파스, 스프레이)", "상처치료, 기타", "의약외품", "영양제", "진통해열제", "연고류", "기타소모품", "기타"],
      form: {
        headerYear: moment(new Date()).format("YYYY"),
        stdInfo: {},

        stockList1: [],
        stockList2: [],
        stockList3: [],
        stockList4: [],
        stockList5: [],
        stockList6: [],
        stockList7: [],
        stockList8: [],
        stockList9: [],
        stockList10: [],

        fileList: [],
      },
    };
  },
  computed: {
    fieldTypes() {
      return ["field_name", "department", "com_name", "rank", "writer_name", "date", "updated_at"];
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    postList() {
      return [...JSON.parse(JSON.stringify(this.$store.state.board.list))].reverse();
    },
    isPostId() {
      return !!this.$route.params.postId;
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

input[type="number"] {
  height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.7rem !important;
  transition: all 0.3s ease;

  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}
</style>
